import { render } from "./App.vue?vue&type=template&id=0b7bcdc2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0b7bcdc2&lang=scss"

import exportComponent from "C:\\Users\\marti\\Desktop\\Projects\\chat-firebas-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__